import debounce from 'lodash/debounce';
import utils from '@bigcommerce/stencil-utils';

export default function () {
    const $quickSearchResults = $('.quickSearchResults');
    const $quickSearchClear = $('.quickSearchInput .modal-close');
    const $quickSearchDiv = $('#quickSearch');
    const $searchQuery = $('#search_query');

    // stagger searching for 200ms after last input
    const doSearch = debounce((searchQuery) => {
        utils.api.search.search(searchQuery, { template: 'search/quick-results' }, (err, response) => {
            if (err) {
                return false;
            }

            $quickSearchResults.html(response);
            $quickSearchClear.show();

            $('.modal-close').on('click', (event) => {
                $quickSearchResults.empty().hide();
                $searchQuery.val('');
                event.preventDefault();
            });
        });
    }, 200);

    utils.hooks.on('search-quick', (event, currentTarget) => {
        // Don't use quick search for mobiles
        if (/Mobi/i.test(navigator.userAgent)) {
            return;
        }

        const searchQuery = $(currentTarget).val();

        // server will only perform search with at least 3 characters
        if (searchQuery.length < 3) {
            return;
        }

        doSearch(searchQuery);
    });

    // Catch the submission of the quick-search
    $quickSearchDiv.on('submit', event => {
        const searchQuery = $(event.currentTarget).find('input').val();

        if (searchQuery.length === 0) {
            return event.preventDefault();
        }

        return true;
    });
}
